<template>
    <div>
        <homeHead></homeHead>
        <homeNav :type="1" ></homeNav>
        <div class="colspan">
            <div class="weizhi"> <img src="../../assets/images/weizhi.png" alt=""> 您当前所在的位置：</div>
            <el-breadcrumb separator="/"> 
                <el-breadcrumb-item   :to="cateInfo.name? {path:'/pubDocument'}:''"  >新闻列表</el-breadcrumb-item> 
                <el-breadcrumb-item v-if="cateInfo.name" >{{cateInfo.name}}</el-breadcrumb-item>   
            </el-breadcrumb>
        </div>
        <projectMenu :path="'/pubDocument'" :projectCateList="menuList" ></projectMenu>
        <pubContent :title="cateInfo.name?cateInfo.name:'新闻列表'" ></pubContent>  
        <homeFooter></homeFooter>
    </div>
    
</template>
<script>
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import projectMenu from '@/components/Public/pubMenu.vue'
import pubContent from '@/components/dynamics/pubContent.vue'
import homeFooter from '@/components/Public/footer.vue'
export default {
    components:{
        homeHead,
        homeNav,
        projectMenu,
        pubContent,
        homeFooter
    },
    metaInfo(){
            return {
                title: this.$store.state.webInfo.title+"-新闻列表",
                meta:[{
                     name: this.$store.state.webInfo.key_words,
                     content: this.$store.state.webInfo.describe
                 }],
                 link: [{                
                    rel: 'asstes',
                    href: this.$url.webUrl
                }]
            } 
        },
    data(){
        return {
            menuList:[{id:null,name:'全部新闻'}],//右侧导航
            cateInfo:{},
        }
    },
    created(){
        this.getmenuList()
    },
    methods:{
        getmenuList(){
            this.$db.get(this.$url.document.cate).then(res=>{
                this.menuList = this.menuList.concat(res.data) 
            }).catch(err => {
            console.log(err);
          });
        },
         getCateName(){
            this.$db.get(this.$url.document.cateInfo+'/'+this.cate_id).then(res=>{
                 this.cateInfo = res.data  
            }).catch(err => {
            console.log(err);
          });
        },
    },
    watch:{
        '$route.query.cate_id':function(value){
            if(value){
                this.cate_id =value
                this.getCateName()
            }else if(typeof(value)=='undefined'){
              this.cateInfo = {}
            }  
        }
    }
}
</script>
<style lang="less" scoped>
.colspan {
    margin: 0 auto;
    width: 1200px;
    height: 50px;
    background-color: #f3f3f3;
    color: #888888;
    font-size: 16px;
    margin-top: 14px;
    margin-bottom: 20px;
    > .weizhi {
        float: left;
        line-height: 50px;
        margin-left: 10px;
        > img {
            vertical-align:text-top;  
        }
    }
    > .el-breadcrumb {
        line-height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamics/pubList.vue